import { useFormContext } from 'react-hook-form'
import Checkbox from '@components/form/Checkbox'
import useT from '@hooks/useTranslation'

const ContextCheckbox = ({ t, ...rest }) => {
    const { register } = useFormContext()
    const label = useT(t || rest.name)
    return <Checkbox {...rest} register={register} label={label} />
}

export default ContextCheckbox